import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import LockIcon from "@mui/icons-material/Lock";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import * as React from "react";

import { RobotoIconButton } from "@/shared/components";

import styles from "./EarlyAccessInfoPopover.module.css";

const POPOVER_WIDTH = 340;
const VIEWPORT_EDGE_PADDING = 8; // Minimum distance from viewport edges
const POPOVER_VERTICAL_OFFSET = 4; // Gap between trigger and popover

export const EarlyAccessInfoPopover = () => {
  const [isOpen, setIsOpen] = React.useState(false);
  const triggerRef = React.useRef<HTMLDivElement>(null);
  const [popoverStyle, setPopoverStyle] = React.useState<React.CSSProperties>(
    {},
  );

  React.useEffect(() => {
    if (isOpen && triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      const viewportWidth = window.innerWidth;

      // Calculate left position, ensuring popover stays within viewport
      let left = rect.left;
      if (left + POPOVER_WIDTH > viewportWidth - VIEWPORT_EDGE_PADDING) {
        left = viewportWidth - POPOVER_WIDTH - VIEWPORT_EDGE_PADDING;
      }

      setPopoverStyle({
        top: rect.bottom + POPOVER_VERTICAL_OFFSET,
        left: Math.max(VIEWPORT_EDGE_PADDING, left),
      });
    }
  }, [isOpen]);

  return (
    <div
      ref={triggerRef}
      className={styles.popoverTrigger}
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
    >
      <RobotoIconButton eventName={"AgentThreadInfoClicked"} size="small">
        <InfoOutlinedIcon className={styles.iconButton} />
      </RobotoIconButton>
      {isOpen && (
        <div className={styles.popoverContent} style={popoverStyle}>
          <div className={styles.popoverSection}>
            <RocketLaunchIcon className={styles.popoverIcon} />
            <div className={styles.popoverTextContainer}>
              <span className={styles.popoverTitle}>Early Access</span>
              <span className={styles.popoverDescription}>
                This AI assistant is in early access preview. If you encounter
                any issues, please reach out—we&apos;ll address them promptly.
              </span>
            </div>
          </div>

          <div className={styles.popoverSection}>
            <span className={styles.popoverEmoji}>🔮</span>
            <div className={styles.popoverTextContainer}>
              <span className={styles.popoverTitle}>AI-Generated Content</span>
              <span className={styles.popoverDescription}>
                Responses are generated by an LLM and may occasionally be
                inaccurate. Always verify important information.
              </span>
            </div>
          </div>

          <div className={styles.popoverSection}>
            <LockIcon className={styles.popoverIcon} />
            <div className={styles.popoverTextContainer}>
              <span className={styles.popoverTitle}>Security First</span>
              <span className={styles.popoverDescription}>
                This tool uses your read-only credentials and cannot modify your
                data or access anything beyond your permissions. Security is
                enforced at the system level, not by the AI.
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
